module.exports = __webpack_public_path__ + "static/media/203.26a8ff06.jpg";